// Fields the IP jobs grid fetches for every job (Step 1 selection, read again on Step 3).
// Also the `job` selection of the CSV import status (DP-3261), so imported jobs behave like
// grid-selected ones. The backend's JOB_IMPORT_JOB_SOURCE_FIELDS mirrors this list.
export const IP_JOB_DEFAULT_FIELDS = [
  "jobId",
  "jobNumber",
  // DP-3156: step 3 reads job.jobAlias off the step-1 selection, and the Job Alias
  // column ships hidden — without this the field is never fetched and step 3 is blank.
  "jobAlias",
  "readyAt",
  "dueBy",
  "service",
  "stops.jobStopId",
  "stops.jobStopStatus",
  "stops.stopType",
  "stops.sequence",
  "stops.manifestSequence",
  "stops.scheduledDateTime",
  "stops.lateDateTime",
  "stops.earlyDateTime",
  "stops.name",
  "stops.address",
  "stops.city",
  "stops.state",
  "stops.zip",
  "stops.timeZone",
  "stops.note",
  "stops.dispatchZone",
  "stops.see",
  "stops.phone",
  "pieces",
  "weight",
  "routeNumber",
  "site.siteId",
  "site.code",
  "vehicleType.vehicleTypeId",
  "order.orderId",
  "order.notes",
  "order.auth",
  "order.alias",
  "order.caller",
  "order.createdDateTime",
  "order.declaredValue",
  "order.codAmount",
  "order.user.userName",
  "order.customer.customerId",
  "order.customer.notes",
  "order.customer.customerCode",
  "order.priority.orderPriorityId",
  "order.priority.description",
  "order.requirements.name",
  "order.orderSkills.id",
  // DP-3230: the Step 3 skill check names a job's missing skills from the job side.
  "order.orderSkills.name",
  "order.orderEvents.eventDateTime",
  "order.orderEvents.eventType",
  "order.orderEvents.note",
  "order.orderEvents.orderEventId",
  "order.orderEvents.userId",
  "order.orderEvents.userName"
];
